import { combineReducers } from 'redux'
import misc from './misc'
import document from './document'

export default combineReducers({
  misc,
  document,
})
